import { Location } from '@angular/common';
import { Component, Input, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { UI } from '../../components/ui';
import { ApiService, DynamicFormComponent } from '@mm-aggregator/drf-dynamics';
import type { EntityConfig } from '../../config/entity-config';
import { ShellRoutesService } from '../../services/shell-routes.service';
import { goBackOrNavigate } from '../../utils/navigation';

/**
 * Edit page: dynamic form with initial values from GET. Submits PATCH to listPath/id/.
 * Use entityConfig.editComponent for a custom form.
 */
@Component({
  selector: 'app-entity-edit-page',
  standalone: true,
  imports: [DynamicFormComponent, ...UI],
  templateUrl: './entity-edit-page.component.html',
})
export class EntityEditPageComponent implements OnInit {
  @Input() entityConfig!: EntityConfig;
  @Input() id!: string;

  private readonly api = inject(ApiService);
  private readonly location = inject(Location);
  private readonly router = inject(Router);
  private readonly shellRoutes = inject(ShellRoutesService);

  readonly initialValue = signal<Record<string, unknown> | null>(null);

  get resourcePath(): string {
    const path = this.entityConfig?.listPath ?? '';
    return path ? `${path.replace(/\/$/, '')}/${this.id}/` : '';
  }

  get entityKey(): string {
    return this.entityConfig?.key ?? '';
  }

  goBack(): void {
    goBackOrNavigate(this.location, this.router, this.shellRoutes.commands('manage', this.entityKey, this.id));
  }

  ngOnInit(): void {
    if (!this.resourcePath) return;
    this.api.get<Record<string, unknown>>(this.resourcePath).subscribe({
      next: (obj) => this.initialValue.set(obj),
      error: () => {},
    });
  }

  onSubmit(value: Record<string, unknown>): void {
    if (!this.resourcePath) return;
    this.api.patch(this.resourcePath, value).subscribe({
      next: () => void this.router.navigate(this.shellRoutes.commands('manage', this.entityKey, this.id)),
      error: () => {},
    });
  }

  onCancel(): void {
    void this.router.navigate(this.shellRoutes.commands('manage', this.entityKey, this.id));
  }
}
